import { React, PT, fetchApi } from '@gasbuddy/react';
import { Header, Button, Modal, Icon, Form, Dropdown } from 'semantic-ui-react';

const reasonOptions = [
  { value: 'admin', text: 'admin' },
  { value: 'lost', text: 'lost' },
  { value: 'stolen', text: 'stolen' },
  { value: 'damaged', text: 'damaged' },
  { value: 'skimmed', text: 'skimmed' },
];

export class ReissueModal extends React.Component {
  state = {}

  reissue = () => {
    const { instrument: { instrument_id: iid, account_id: aid } } = this.props;
    const { reason, fee } = this.state;
    this.setState({}, async () => {
      const { status, error } = await fetchApi({
        url: `/payments/instrument/reissue/${aid}/${iid}`,
        catchErrors: true,
        body: {
          reason,
          fee,
        },
      });
      if (status === 200) {
        this.setState({ opened: false });
      } else {
        // eslint-disable-next-line no-alert, no-undef
        alert(`Failed to reissue: ${error.status} ${error}`);
      }
    });
  }

  render() {
    const { reason, opened } = this.state;
    return (
      <Modal
        open={opened}
        trigger={(
          <Button
            floated="right"
            onClick={() => this.setState({ opened: true })}
          >
          Terminate and Reissue
          </Button>
)}
      >
        <Header icon="attention" content="Are You Sure?" />
        <Modal.Content>
          <p>
Are you sure you want to terminate this Wex Card,
            issue a new number, and re-ship the new card to the address
            on file?
          </p>
          <p>
If you need to change the address, for now, contact Max
            and coordinate changing the address. (Coordinate before
            clicking this button).
          </p>
          <Form>
            <Form.Field>
              <Dropdown
                placeholder="Select the reason the card needs to be reissued"
                value={reason || 'admin'}
                options={reasonOptions}
                onChange={(e, el) => this.setState({ reason: el.value })}
                search
                selection
              />
            </Form.Field>
            <Form.Checkbox
              label="Charge the user a shipping and handling fee"
              onChange={(d, v) => this.setState({ fee: v.checked })}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button basic color="grey" onClick={() => this.setState({ opened: false })}>
            <Icon name="minus" />
            {' '}
Leave Account As Is
          </Button>
          <Button basic color="red" onClick={this.reissue}>
            <Icon name="trash" />
            {' '}
Terminate and Reissue
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

ReissueModal.propTypes = {
  instrument: PT.shape({
    instrument_id: PT.number,
    account_id: PT.number,
  }).isRequired,
};
